(function() {

	angular
		.module('ngmvac')
		.factory('ReservationFactory', ReservationFactory);

	ReservationFactory.$inject = ['$http', '$rootScope'];

	function ReservationFactory($http, $rootScope) {
		return {
			addConfirmation: addConfirmation,
			timeSinceBooking : timeSinceBooking,
			sendExtraRate: sendExtraRate,
		}	

		function addConfirmation(data) {
			return $http.post('/reservation', data);
		}

		function timeSinceBooking(){
			return $http.get('/timeSinceBooking');
		}

		function sendExtraRate(key, value) {
			$rootScope.$broadcast('extraRate', value);
		}
	}

})();